import React, { useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  FormControl,
  FormLabel,
  Button,
  FormControlLabel,
} from "@mui/material";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";
import FileChooser from "./FileChooser";
import "./styles/Settings.css";

function SettingsMaintenance(props) {
  const creds = useContext(CredsContext).creds;
  const localSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const settingsArray = Object.entries(localSettings);

  const localStorageKeys = [
    {
      displayName: "Clear Master Project List",
      keyNames: [
        creds.company + "|ClientsProjects",
        creds.company + "|FavoriteProjects",
      ],
    },
    {
      displayName: "Clear Selected (Favorite) Projects List",
      keyNames: [creds.company + "|FavoriteProjects"],
    },

    {
      displayName: "Clear Collab Center Settings",
      keyNames: ["oadaSettingss"],
    },
    {
      displayName: "Clear Cached Issue Stages, Categories, Priorities",
      keyNames: [
        creds.company + "|IssueStage",
        creds.company + "|IssueCategory",
        creds.company + "|IssueSeverity",
      ],
    },
  ];

  const handleClick = (event) => {
    const selectedButtonText = event.target.value;
    const keyArray = localStorageKeys.find(
      (elem) => elem.displayName == selectedButtonText,
    ).keyNames;
    keyArray.forEach((elem) => localStorage.removeItem(elem));
  };

  const handleClickTestFunction = () => {
    Tools.gDrivePost();
  };

  const toGDrive = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve("foo");
        Tools.gDrivePost(reader.result, file.name, file.type).then(
          (response) => {
            console.log("Rep: " + JSON.stringify(response));
          },
        );
        //Tools.gDrivePost(reader.result, file.name, file.type);
      };

      reader.onerror = reject;
    });
  //reader.onload = () => {
  //  console.log(reader.result);
  //};

  const handleFileChange = (event) => {
    //Tools.gDrivePost(event);
    const dummy = toGDrive(event);
  };
  return (
    <Box>
      <Box>
        <FormControl>
          <FormLabel>
            <div className="settingsGroupTitle">Maintenance Tasks</div>
          </FormLabel>
          {localStorageKeys.map((lskObject) => (
            <FormControlLabel
              key={lskObject.displayName}
              control={
                <Button
                  variant="contained"
                  value={lskObject.displayName}
                  onClick={handleClick}
                  className="settingsButtonActive"
                  sx={{ margin: "5px 5px 5px 20px !important", width: "400px" }}
                >
                  {lskObject.displayName}
                </Button>
              }
            />
          ))}
        </FormControl>
      </Box>
      <Box>
        <Box sx={{ padding: "20px" }}>
          <Typography sx={{ color: "white" }}>Stored Settings</Typography>
          <Box
            sx={{
              padding: "10px",
              border: "solid 1px",
              borderColor: "white",
              width: "800px",
            }}
          >
            {settingsArray.map((elem, index) => (
              <Box key={index} display="flex" width={"750px"}>
                <Typography
                  sx={{ color: "white", paddingRight: "10px" }}
                  noWrap={true}
                >
                  {elem[0]}
                </Typography>
                <Typography sx={{ color: "cyan" }} noWrap={true}>
                  {JSON.stringify(elem[1])}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SettingsMaintenance;

SettingsMaintenance.propTypes = {
  handleSettingsChange: PropTypes.func,
};

/*          <FormControlLabel
            control={
              <Button
                variant="contained"
                value={"Test function"}
                onClick={handleClickTestFunction}
                className="settingsButtonActive"
                sx={{ margin: "5px 5px 5px 20px !important", width: "400px" }}
              >
                Test function
              </Button>
            }
          />*/
/*
          <FileChooser
          changeHandler={handleFileChange}
          id="__dashboardProjectDocumentsFileChooser"
        />*/
